export const PAYMENT_METHODS = [
  { id: 0, text: 'BANK', value: 0 },
  { id: 1, text: 'CASH', value: 1 },
  { id: 2, text: 'CARD_PAYMENT', value: 2 },
  { id: 3, text: 'INSTALLMENT_PLAN', value: 3 },
  { id: 5, text: 'ONLINE_CARD_LIQPAY', value: 5 },
  { id: 6, text: 'ONLINE_CARD_MONOBANK', value: 6 },
  { id: 4, text: 'Xpay', value: 4 }
];
